/**
=========================================================
* Trust Cargo - the note under a field
=========================================================

* The hint or the error under a box: small, lined up with the box's edge,
* close enough to it to belong to it.
*/

import pxToRem from "assets/theme/functions/pxToRem";

const formHelperText = {
  styleOverrides: {
    root: {
      marginTop: pxToRem(4),
      marginLeft: 0,
      marginRight: 0,
      fontSize: pxToRem(12),
      lineHeight: 1.35,
    },
  },
};

export default formHelperText;
